export default __webpack_public_path__ + "static/media/product-launch.6620e176.svg";